module.exports = __webpack_public_path__ + "static/bt-b9e070d41e5fd1771ee522a8b89fb932.png";